import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	PoweredByAtlas: {
		id: 'ptc-atlas.profile-page.manager-and-teams-chart.reporting-lines.empty-state.powered-by-atlas',
		defaultMessage: 'Powered by Atlas',
		description:
			'Message when admin has not connected IdP explaining which product powers this feature',
	},
});
